// export const WEB_ADDRESS = 'http://localhost:3000';
export const WEB_ADDRESS = 'https://dogfight.y-backend.com';
export const GAME_WEB_ADDRESS = WEB_ADDRESS + '/dogfight.html';

// export const GAME_SOCKET_ADDRESS = 'ws://localhost:1700';
export const GAME_SOCKET_ADDRESS = 'wss://y-backend.com:1700';
